import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "jobos_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = (accepted: boolean) => {
    setAnimateOut(true);
    setTimeout(() => {
      localStorage.setItem(COOKIE_KEY, accepted ? "accepted" : "declined");
      setVisible(false);
    }, 350);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-2xl px-4 transition-all duration-350 ${
        animateOut
          ? "opacity-0 translate-y-6 pointer-events-none"
          : "opacity-100 translate-y-0"
      }`}
      style={{ transition: "opacity 0.35s ease, transform 0.35s ease" }}
    >
      <div className="bg-[#0F1629] border border-[#2D3148] rounded-2xl shadow-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon */}
        <div className="w-10 h-10 flex items-center justify-center shrink-0 bg-[#6366F1]/10 rounded-xl">
          <i className="ri-cookie-line text-[#6366F1] text-xl"></i>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-[#F8FAFC] text-sm font-semibold mb-0.5">
            We use cookies 🍪
          </p>
          <p className="text-[#94A3B8] text-xs leading-relaxed">
            We use cookies to improve your experience and analyze site traffic.
            By continuing, you agree to our{" "}
            <Link
              to="/privacy"
              className="text-[#6366F1] hover:text-[#818CF8] underline underline-offset-2 transition-colors"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => dismiss(false)}
            className="h-9 px-4 rounded-full text-xs font-medium text-[#94A3B8] border border-[#2D3148] hover:border-[#475569] hover:text-[#F8FAFC] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Decline
          </button>
          <button
            onClick={() => dismiss(true)}
            className="h-9 px-5 rounded-full text-xs font-semibold bg-[#6366F1] text-white hover:bg-[#4F46E5] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
